import { TaskStatusFragment } from "gql/graphql";
import { useTranslations } from "use-intl";
import { Hidable, Value } from "@/shared/value";
import { isTaskDone } from "../completion";

/**
 * Статус задачи словами. Раньше список и тег писали одно и то же состояние
 * по-разному («В процессе» против «Не выполнено»), потому что каждый решал сам.
 */
export function TaskStatus({ data }: { data?: Hidable<TaskStatusFragment> }) {
  const t = useTranslations("Tasks");

  return (
    <Value data={data}>
      {(task) => <span>{isTaskDone(task) ? t("Done") : t("In progress")}</span>}
    </Value>
  );
}
